import React, { useState, useEffect } from "react";

const testimonials = [
  {
    name: "अरुण जेटली",
    position: "वित्त मंत्री",
    message: "श्री संजय परदेशी जी ऊर्जा, कड़ी मेहनत, ज्ञान और दक्षता के धनी हैं।",
    image: "/images/user-profile.png",
  },
  {
    name: "राजनाथ सिंह",
    position: "रक्षा मंत्री",
    message: "वह एक सुरक्षित और सुरक्षित भारत सुनिश्चित करने के लिए जबरदस्त प्रयास कर रहे हैं।",
    image: "/images/user-profile.png",
  },
  {
    name: "जेपी नड्डा",
    position: "भाजपा अध्यक्ष",
    message: "श्री संजय परदेशी जी ऊर्जा, कड़ी मेहनत, ज्ञान और दक्षता के धनी हैं।",
    image: "/images/user-profile.png",
  },
  {
    name: "रजनीकांत",
    position: "अभिनेता",
    message: "श्री संजय परदेशी जी ने मिशन कश्मीर के संचालन में जो किया वह वास्तव में सराहनीय है।",
    image: "/images/user-profile.png",
  },
];

export default function TestimonialsSection() {
  const [start, setStart] = useState(0);
  const visible = 3;
  const total = testimonials.length;

  // Auto-rotate every 6 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setStart((prev) => (prev + 1) % total);
    }, 6000);
    return () => clearInterval(interval);
  }, [total]);

  const getVisible = () => {
    const arr = [];
    for (let i = 0; i < visible; i++) {
      arr.push(testimonials[(start + i) % total]);
    }
    return arr;
  };

  const prevSlide = () => {
    setStart((prev) => (prev - 1 + total) % total);
  };

  const nextSlide = () => {
    setStart((prev) => (prev + 1) % total);
  };

  return (
    <section className="py-10 bg-white select-none">
      <div className="max-w-7xl mx-auto px-4">
        {/* Section Header */}
        <div className="flex justify-between items-center mb-6">
          <div className="bg-orange-400 rounded-tl-2xl rounded-br-2xl px-6 py-2">
            <span className="text-white text-xl font-bold" style={{ fontFamily: "Mukta, Arial, sans-serif" }}>
              दिग्गज बोल
            </span>
          </div>
          <div className="flex items-center space-x-2">
            <button
              onClick={prevSlide}
              className="bg-white/80 hover:bg-white text-orange-600 rounded-full p-2 shadow-lg transition-colors duration-200"
              aria-label="Previous testimonials"
            >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
              </svg>
            </button>
            <button
              onClick={nextSlide}
              className="bg-white/80 hover:bg-white text-orange-600 rounded-full p-2 shadow-lg transition-colors duration-200"
              aria-label="Next testimonials"
            >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
              </svg>
            </button>
          </div>
        </div>

        {/* Testimonials Row */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {getVisible().map((t, i) => {
            const isCenter = i === 1;
            return (
              <div
                key={i}
                className={`flex items-center transition-all duration-300 cursor-pointer shadow-md px-2 py-1 h-full
                  ${isCenter ? "bg-orange-400 text-white" : "bg-gray-100 text-gray-900 hover:bg-orange-400 hover:text-white"}
                  rounded-tl-full rounded-bl-full rounded-br-3xl`}
                style={{ fontFamily: 'Mukta, Arial, sans-serif' }}
              >
                {/* Image */}
                <img
                  src={t.image}
                  alt={t.name}
                  className="w-20 h-20 rounded-full object-cover border-4 border-white shadow bg-white flex-shrink-0 mr-4"
                />
                {/* Text */}
                <div className="flex flex-col justify-center">
                  <p className="text-[1rem] leading-snug">{t.message}</p>
                  <p className="text-sm font-semibold mt-2">{t.position}, {t.name}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
